import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20b70f6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "pic" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "play" }, null, -1))
const _hoisted_5 = ["title", "textContent"]

import imgPH from "@/assets/images/ph_16_9.png";
import { computed, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import videos from "./Videos";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const store = useStore();
const isMobile = computed(() => !!store.state.isMobile);
const language = computed(() => store.state.appLanguage);
const videoLists = reactive(videos);
const router = useRouter();
const openInfo = (id: number) => {
  router.push({
    name: "helpVideoInfo",
    params: {
      id,
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['box', { mobileSize: _unref(isMobile) }])
  }, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoLists, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          onClick: ($event: any) => (openInfo(item.id))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _unref(imgPH),
              style: _normalizeStyle(`background-image:url(${item.poster})`)
            }, null, 12, _hoisted_3),
            _hoisted_4
          ]),
          _createElementVNode("div", {
            class: "title",
            title: _unref(language) === 'zh' ? item.title : item.titleEn,
            textContent: _toDisplayString(_unref(language) === 'zh' ? item.title : item.titleEn)
          }, null, 8, _hoisted_5)
        ], 8, _hoisted_1))
      }), 128))
    ])
  ], 2))
}
}

})